import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTaskDone = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 11,
			height: 11,
			rx: 5.5,
			fill: "#EFFCF5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 11,
			height: 11,
			rx: 5.5,
			stroke: "#7DD5A8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.375 6.11667L5.00833 7.75L8.50833 4.25",
			stroke: "#1E8553",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgTaskDone;
